import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@mui';
import './show-more.scss';

const ShowMore = ({ onClick, open }) => {
  const label = `Show ${open ? 'less' : 'more'} results`;
  return (
    <button
      aria-label={label}
      onClick={onClick}
      styleName="show-more-container"
      type="button"
    >
      <div styleName="icon">
        <Icon role="img" aria-hidden="true">more_horiz</Icon>
      </div>
      <div styleName="text">
        SHOW { open ? 'LESS' : 'MORE' } RESULTS
      </div>
    </button>
  );
};

ShowMore.propTypes = {
  onClick: PropTypes.func,
  open: PropTypes.bool
};

export default ShowMore;
